import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const EntityShareDetail = lazy(() => import('./entity-share-detail/entity-share-detail.component'));
const EntityShareOverview = lazy(() => import('./entity-share-overview'));
const EntityShareCreate = lazy(() => import('./entity-share-create/entity-share-create.component'));
const EntityShareUpdate = lazy(() => import('./entity-share-update/entity-share-update.component'));

export function EntityShareRoutes() {
    return (
        <Route path='entity-shares'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <EntityShareOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <EntityShareCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':entityShareId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <EntityShareDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <EntityShareUpdate />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
